/**
 * @file The typed rejection a blocked derive draft aborts a FormType save with
 * (spec §7). Thrown by `useLayoutEditorForm`'s `onSave` before it touches
 * Firestore, caught by `LayoutEditorToolbar`, which switches to the Derived
 * values pane so the pane can open wireframe W5.
 * Invariants: it carries the whole `FormDeriveDraftVerdict`, so no consumer has
 * to re-judge and none can soften the verdict toward "valid"; it is thrown, not
 * returned, because the entire FormType update has to abort — derives are never
 * saved partially, and an entry the engine would drop computes nothing and does
 * not even bump the rev, so nothing downstream would ever repair it.
 */
import type { FormDeriveDraftVerdict } from './validateFormDeriveDraft';

class FormDerivesBlockedError extends Error {
  readonly verdict: FormDeriveDraftVerdict;

  constructor(verdict: FormDeriveDraftVerdict) {
    super('Derived values are blocked and were not saved.');
    this.name = 'FormDerivesBlockedError';
    this.verdict = verdict;
  }
}

export { FormDerivesBlockedError };
